import React from "react";

// The Swyvel AI mark: one four-point spark in the /ai page's accent blue.
// Drawn once so the header pill, the drawer title, the proposal cards and
// every "made by Swyvel AI" badge share a glyph, instead of an emoji that
// renders differently on every OS.
export const SparkMark = ({ size = 16, color = "#8FB6FF", className, style }) => (
  <svg width={size} height={size} viewBox="0 0 16 16" aria-hidden="true" focusable="false"
       className={className} style={{ display: "block", flex: "0 0 auto", ...style }}>
    <path fill={color} d="M8 1.25c.55 3.55 3.2 6.2 6.75 6.75C11.2 8.55 8.55 11.2 8 14.75 7.45 11.2 4.8 8.55 1.25 8 4.8 7.45 7.45 4.8 8 1.25Z" />
  </svg>
);

// The header pill's look as a label, for features Swyvel AI powers outside
// the chat (the campaign builder's "Write it for me"). Not a button.
export const SwyvelAIBadge = ({ style }) => (
  <span
    style={{
      display: "inline-flex", alignItems: "center", gap: 6, height: 28, padding: "0 12px 0 10px",
      background: "#1b2547", color: "#ffffff", border: "1px solid rgba(143,182,255,.38)", borderRadius: 140,
      fontFamily: "'Nunito', 'Varela Round', sans-serif", fontSize: 12.5, fontWeight: 700, lineHeight: 1,
      whiteSpace: "nowrap", boxShadow: "0 1px 2px rgba(27,37,71,.18)", ...style,
    }}
  >
    <SparkMark size={14} />
    Swyvel AI
  </span>
);

export default SparkMark;
